import { render, staticRenderFns } from "./Mentora.vue?vue&type=template&id=1694f1b2&"
import script from "./Mentora.vue?vue&type=script&lang=js&"
export * from "./Mentora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports